import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=04aa9fca&scoped=true&"
import script from "./PropertySelect.vue?vue&type=script&lang=js&"
export * from "./PropertySelect.vue?vue&type=script&lang=js&"
import style0 from "./PropertySelect.vue?vue&type=style&index=0&id=04aa9fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa9fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04aa9fca')) {
      api.createRecord('04aa9fca', component.options)
    } else {
      api.reload('04aa9fca', component.options)
    }
    module.hot.accept("./PropertySelect.vue?vue&type=template&id=04aa9fca&scoped=true&", function () {
      api.rerender('04aa9fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertySelect.vue"
export default component.exports